import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { faClose } from '@fortawesome/pro-solid-svg-icons';
import { forwardRef, useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { Button, IconButton, Text } from '../..';
import { MODAL_ACTION_BUTTON_CANCEL_ARIA_LABEL, MODAL_ACTION_BUTTON_SUCCESS_ARIA_LABEL, MODAL_DEFAULT_BUTTONS_FULL_WIDTH, MODAL_DEFAULT_BUTTON_CANCEL, MODAL_DEFAULT_BUTTON_SUCCESS, MODAL_DEFAULT_CLOSEABLE, MODAL_DEFAULT_DISABLE_ESC_KEY, MODAL_DEFAULT_DISABLE_OUTSIDE_CLICK, MODAL_DEFAULT_IS_OPEN, MODAL_DEFAULT_SIZE, MODAL_PORTAL_DIV_CLASSNAME, MODAL_PORTAL_DIV_ID, MODAL_TOP_BUTTON_ARIA_LABEL } from './Modal.constants';
import { useModal } from './Modal.hooks';
import { ModalButtons, ModalContent, ModalOverlay, ModalRoot, ModalTitle } from './Modal.styled';
// Component.
// -----------------------------------------------------------------------------
const Modal = forwardRef(({ buttonCancel, buttonSuccess, buttonsFullWidth = MODAL_DEFAULT_BUTTONS_FULL_WIDTH, buttonsSlot, children, closeable = MODAL_DEFAULT_CLOSEABLE, disableEscKey = MODAL_DEFAULT_DISABLE_ESC_KEY, disableOutsideClick = MODAL_DEFAULT_DISABLE_OUTSIDE_CLICK, isOpen = MODAL_DEFAULT_IS_OPEN, onClose, size = MODAL_DEFAULT_SIZE, title, ...rest }, ref) => {
    // Hooks.
    // -------------------------------------------------------------------------
    const [portalId, setPortalId] = useState('');
    const refModal = useRef(null);
    const { onClickCross } = useModal({
        disableEscKey,
        disableOutsideClick,
        isOpen,
        onClose,
        ref,
        refModal
    });
    // Effect.
    // -------------------------------------------------------------------------
    useEffect(() => {
        if (isOpen) {
            const portals = document.querySelectorAll(`.${MODAL_PORTAL_DIV_CLASSNAME}`);
            const portalSeq = portals.length === 0 ? 0 : portals.length - 1;
            const currentPortalId = `${MODAL_PORTAL_DIV_ID}-${portalSeq}`;
            const currentPortal = document.getElementById(currentPortalId);
            const fnCreateNode = (theId) => {
                const div = document.createElement('div');
                div.classList.add(MODAL_PORTAL_DIV_CLASSNAME);
                div.setAttribute('id', theId);
                document.body.append(div);
            };
            if (!currentPortal) {
                fnCreateNode(currentPortalId);
                setPortalId(currentPortalId);
            }
            else if (currentPortal.childElementCount === 0) {
                const portalDivId = `${MODAL_PORTAL_DIV_ID}-${portalSeq + 1}`;
                fnCreateNode(portalDivId);
                setPortalId(portalDivId);
            }
            else {
                setPortalId(currentPortalId);
            }
        }
    }, [isOpen]);
    // Guard condition.
    // -------------------------------------------------------------------------
    if (!isOpen ||
        typeof window === 'undefined' ||
        (typeof window !== 'undefined' && !document.getElementById(portalId))) {
        return null;
    }
    // Render.
    // -------------------------------------------------------------------------
    return createPortal(_jsx(ModalOverlay, { children: _jsxs(ModalRoot, { "aria-modal": true, "aria-labelledby": "modal-title", ref: refModal, role: "alertdialog", size: size, ...rest, children: [title && (_jsx(ModalTitle, { id: "modal-title", children: _jsx(Text, { bold: true, size: "xl", children: title }) })), closeable && (_jsx(IconButton, { "aria-label": MODAL_TOP_BUTTON_ARIA_LABEL, className: "btn__close", icon: faClose, onClick: onClickCross })), _jsx(ModalContent, { children: children }), (buttonSuccess || buttonCancel || buttonsSlot) && (_jsxs(ModalButtons, { buttonsFullWidth: buttonsFullWidth, children: [buttonSuccess && (_jsx(Button, { ...MODAL_DEFAULT_BUTTON_SUCCESS, ...buttonSuccess, "aria-label": MODAL_ACTION_BUTTON_SUCCESS_ARIA_LABEL })), buttonCancel && (_jsx(Button, { ...MODAL_DEFAULT_BUTTON_CANCEL, ...buttonCancel, "aria-label": MODAL_ACTION_BUTTON_CANCEL_ARIA_LABEL })), buttonsSlot] }))] }) }), document.getElementById(portalId));
});
// Component configuration.
// -----------------------------------------------------------------------------
Modal.displayName = 'Modal';
export default Modal;
//# sourceMappingURL=Modal.js.map